export default __webpack_public_path__ + "static/media/button-next.8f06104b.svg";